import React, {useEffect, useState} from 'react';
import _ from 'lodash';
import classnames from 'classnames/bind';
import {ISearchVehicle as IVehicle, Replacement} from '../../interface';
import style from './index.module.scss';
import Filter from '../../utils/filter';
import Paginator from '../SearchPaginator';
import underline from '../../utils/underline';
import paginatorConfig from '../../config/paginatorConfig';
import localesReplacement from '../../utils/localesReplacement';
import DOMPurify from 'dompurify';

export interface IFilterResultProps {
  dataList: IVehicle[];
  vehicleType?: string;
  make?: string;
  model?: string;
  year?: string;
  className?: string;
  sort?: boolean;
  onSelect?: (value: string, model:string, vehicleType?: string) => void;
  value?: string;
  replacements: Replacement;
}

const cx = classnames.bind(style);

function FilterResult(props: IFilterResultProps) {
  const {
    dataList,
    vehicleType,
    make,
    model,
    year,
    className,
    sort,
    value,
    onSelect,
    replacements,
  } = props;

  const [vehicles, setVehicles] = useState<IVehicle[]>();
  const [pageIndex, setPageIndex] = useState<number>(0);
  const [mPageIndex, setMPageIndex] = useState<number>(0);
  const limit = paginatorConfig.LIMIT;
  const mobileVehicles = _.take(vehicles, limit * (mPageIndex + 1));
  useEffect(() => {
    const _dataList = new Filter(dataList)
      .vehicleType(vehicleType)
      .manufacturer(make)
      .model(model)
      .year(year)
      .value();
    if (sort) {
      setVehicles(
        _.orderBy(
          _dataList,
          ['make', 'yearFrom', 'yearTo'],
          ['asc','desc', 'desc'],
        ),
      );
    } else {
      setVehicles(_dataList);
    }
    setPageIndex(0);
    setMPageIndex(0);
  }, [dataList, vehicleType, make, model, year]);
  const changeIndex = (index: number) => {
    setPageIndex(index);
  };
  const showMore = () => {
    setMPageIndex(mPageIndex + 1);
  };
  const selectVehicle = (vehicle: IVehicle) => {
    if (onSelect) {
      onSelect(vehicle['id'], vehicle['model'], vehicle.vehicleType);
      sessionStorage.setItem('vehicleType', vehicle.vehicleType);
    }
  };
  return (
    <>
      {!_.isEmpty(vehicles) && (
        <div
          className={cx(
            'result',
            {
              'with-paginator':
                vehicles && Math.ceil(vehicles.length / limit) > 1,
            },
            `${className}`,
          )}
        >
          <div className={cx('result-heading')}>
            <ul>
              <li>{localesReplacement(replacements, 'Model')}</li>
              <li>{localesReplacement(replacements, 'Description')}</li>
              <li>{localesReplacement(replacements, 'Year')}</li>
              <li></li>
            </ul>
          </div>
          {_.chain(vehicles)
            .chunk(limit)
            .get(pageIndex)
            .map(vehicle => (
              <div
                key={vehicle.id}
                className={cx('result-row', 'desktop')}
                onClick={() => selectVehicle(vehicle)}
              >
                <ul>
                  <li
                    dangerouslySetInnerHTML={{
                      __html: DOMPurify.sanitize(
                        `${underline(vehicle['make'], value)}  ${
                          vehicle['model']
                            ? underline(vehicle['model'], value)
                            : ''
                        }`,
                      ),
                    }}
                  ></li>
                  <li>{vehicle['type']}</li>
                  <li>{`${vehicle['yearFrom']} - ${
                    !_.isNull(vehicle['yearTo']) ? vehicle['yearTo'] : ''
                  }`}</li>
                  <li>
                    <span className={cx('expend')}></span>
                    <button className={cx('recommonended-btn')}>
                      {localesReplacement(
                        replacements,
                        'View recommended oils',
                      )}
                    </button>
                  </li>
                </ul>
              </div>
            ))
            .value()}
          {_.map(mobileVehicles, (vehicle, index) => (
            <div
              key={index}
              className={cx('result-row', 'mobile')}
              onClick={() => selectVehicle(vehicle)}
            >
              <ul>
                <li
                  dangerouslySetInnerHTML={{
                    __html: DOMPurify.sanitize(
                      `${underline(vehicle['make'], value)}  ${
                        vehicle['model']
                          ? underline(vehicle['model'], value)
                          : null
                      }`,
                    ),
                  }}
                ></li>
                <li>{vehicle['type']}</li>
                <li>{`${vehicle['yearFrom']} - ${vehicle['yearTo']}`}</li>
              </ul>
            </div>
          ))}
          {!!vehicles && mobileVehicles.length < vehicles.length && (
            <div className={cx('btn-show-more')}>
              <span onClick={showMore}>
                {localesReplacement(replacements, 'Show more')}
              </span>
            </div>
          )}
          {!!vehicles && (
            <Paginator
              index={pageIndex}
              changeIndexHandler={changeIndex}
              total={Math.ceil(vehicles.length / limit)}
            />
          )}
        </div>
      )}
    </>
  );
}

export default FilterResult;
